export default {"src":"/_next/static/media/storybook.205c8a98.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};